import { render } from "./CreatePromo.vue?vue&type=template&id=0c648fe4"
import script from "./CreatePromo.vue?vue&type=script&lang=js"
export * from "./CreatePromo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__